module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-4.4689c1a1.png";